export default __webpack_public_path__ + "static/media/logo.378f1127.svg";